import { isBoolean } from "presentation/utils/functions/generic";

// StageCriterias methods
// Carrega um item no state
export const loadStageCriteria = (key, component) => {
    const { stageCriterias } = component.state;
    let output = undefined;

    if (stageCriterias.length > 0) {
        var item = stageCriterias.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }
    return output;
}

// Monta a lista no state
export const mountStageCriteriaItems = (component) => {

    const { totalStageCriteriaItems, stageCriterias } = component.state;

    const deleteRequested = stageCriterias.filter(x => x.isDeleteRequested === true);

    let newStageCriterias = [];

    for (let i = 0; i < totalStageCriteriaItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultItemId = null;
        let defaultEvaluationSchemeId = null;
        let defaultName = undefined;

        let newItem = {
            key: itemKey,
            id: defaultItemId,
            evaluationSchemeId: defaultEvaluationSchemeId,
            name: defaultName
        };


        let stageCriteria = loadStageCriteria(itemKey, component);

        if (stageCriteria !== undefined) {
            newItem = { ...stageCriteria };
        }

        newStageCriterias.push(newItem);
    }

    let finalStageCriterias = [...newStageCriterias, ...deleteRequested];

    component.setState({ stageCriterias: finalStageCriterias });
}

//Carrega as informações de um campo específico do item no state
export const stageCriteriasFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadStageCriteria(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangeStageCriterias = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');
    const isTrueUnique = (event.target.getAttribute('data-field-is-true-unique') === "true");
    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component, isTrueUnique);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component, isTrueUnique = false) => {
    var item = loadStageCriteria(key, component);

    item = { ...item, [field]: value };

    const newStageCriterias = changeStageCriteriasList(component, item);

    let finalOptions = beforeChangeStageCriteriasState(key, field, value, newStageCriterias, component, isTrueUnique);

    component.setState({
        stageCriterias: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangeStageCriteriasState = (key, changedField, changeValue, newStageCriterias, component, isTrueUnique = false) => {


    let output = newStageCriterias.map((le, i) => {
        if (!le.id) {
            let tempId = generateStageCriteriaVirtualId();
            le.id = tempId;
            le.tempId = tempId;
            le.isVirtualId = true;
        }
        return le;
    });
    //Apenas um item desse tipo de campo pode ser true
    if (isTrueUnique == true && isBoolean(changeValue) && changeValue === true) {
        output = newStageCriterias.map((e, i) => {
            if (e.key !== key) {
                e[changedField] = false;
            }
            return e;
        });
    }



    return output;
}

export const generateStageCriteriaVirtualId = () => {
    return `temp-stage-criteria-${new Date().getTime()}`;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changeStageCriteriasList = (component, targetOption, remove = false) => {
    let { stageCriterias } = component.state;

    let optionIndex = stageCriterias.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = stageCriterias[optionIndex]['id'] || undefined;
        let isVirtualId = stageCriterias[optionIndex]['isVirtualId'] || false;

        let isApiDeleteRequired = isVirtualId ? false : (elementId ? true : false);

        if (isApiDeleteRequired) {
            stageCriterias[optionIndex]['isDeleteRequested'] = true;
            stageCriterias[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            stageCriterias.splice(optionIndex, 1);
        }
    } else {
        stageCriterias[optionIndex] = targetOption;
    }

    return stageCriterias;
}


const stageCriteriasFunctions = {
    loadStageCriteria,
    stageCriteriasFormValue,
    handleChangeStageCriterias,
    beforeChangeStageCriteriasState,
    changeStageCriteriasList,
    mountStageCriteriaItems,
    generateStageCriteriaVirtualId
}

export default stageCriteriasFunctions;